export default __webpack_public_path__ + "static/media/Common_open.38480f9a.webm";